import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { Bau365FeatureBreadcrumbModule } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureUserProfileSharedModule } from '@planone/bau365/feature-user-profile';
import { Bau365FeatureWatchlistSharedModule } from '@planone/bau365/feature-watchlist';
import { SharedDataAccessSwiperModule } from '@planone/shared/data-access-swiper';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { SharedUiSwiperModule } from '@planone/shared-feature-swiper';

import { SectionProductContactPersonsComponent } from './page-product-details/section-contact-persons/section-contact-persons.component';
import { SectionProductCountryAvailabilityComponent } from './page-product-details/section-country-availability/section-country-availability.component';
import { SectionProductExhibitorInfoComponent } from './page-product-details/section-exhibitor-info/section-exhibitor-info.component';
import { SectionProductHeaderComponent } from './page-product-details/section-header/section-header.component';
import { SectionProductInfoComponent } from './page-product-details/section-info/section-info.component';
import { SectionProductKeyFactsComponent } from './page-product-details/section-key-facts/section-key-facts.component';
import { SectionProductMediaComponent } from './page-product-details/section-media/section-media.component';
import { SectionProductProductReferencesComponent } from './page-product-details/section-product-references/section-product-references.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductCardListComponent } from './product-card-list/product-card-list.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiElementsModule,
    Bau365DataAccessFairDataModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureWatchlistSharedModule,
    Bau365FeatureUserProfileSharedModule,
    MatIconModule,
    SharedUtilPipelinesModule,
    SharedDataAccessSwiperModule,
    SharedUiSwiperModule,
    MatTabsModule,
    MatButtonModule,
    MatChipsModule,
    RouterLink,
  ],
  declarations: [
    ProductCardComponent,
    ProductCardListComponent,
    SectionProductHeaderComponent,
    SectionProductExhibitorInfoComponent,
    SectionProductKeyFactsComponent,
    SectionProductCountryAvailabilityComponent,
    SectionProductInfoComponent,
    SectionProductContactPersonsComponent,
    SectionProductMediaComponent,
    SectionProductProductReferencesComponent,
  ],
  exports: [
    ProductCardComponent,
    ProductCardListComponent,
    SectionProductHeaderComponent,
    SectionProductExhibitorInfoComponent,
    SectionProductKeyFactsComponent,
    SectionProductCountryAvailabilityComponent,
    SectionProductInfoComponent,
    SectionProductContactPersonsComponent,
    SectionProductMediaComponent,
    SectionProductProductReferencesComponent,
  ],
})
export class Bau365FeatureProductsSharedModule {}
